<template>
  <div class="wrapper">
    <div class="noneTenement" v-if="lists.length == 0 && showPage">
      <div class="noneIconbg">
        <img src="../../assets/images/noComp.png" />
      </div>
      <span class="noneText1">认证企业来享受更多福利吧</span>
      <span class="noneText">完善企业认证信息，跟我们一起解锁新技能，体验更加酷炫的办公体验</span>
      <span class="noneAdd" @click="addTenement">认证企业</span>
    </div>
    <div v-else :class="[isshowAddPhone? 'tenementList1' :'tenementList']" >
      <div class="list">
        <div
          :class="['cardBox',(activeId == list.id && list.status == 1)?'activeCard':'',(activeId == list.id && (list.status == 2 || list.status == 3))?'activeCard_d':'']"
          v-for="(list,index) in lists"
          :key="index"
           @click="setActiveId(list)">
          <div class="card">
            <div class="line1 border-bottom"></div>
            <div class="leftCard">
              <div class="titleBox">
                <span class="presermission" v-if="list.isDeafult">默认</span>
                <span class="cardTitle">{{list.company}}</span>
              </div>
              <div class="addressView">
                <img class="addressIcon" src="../../assets/images/project.png" />
                <span class="address">{{list.marketName}}</span>
              </div>
              <div class="userInfo1">
                <span class="userName userN">{{list.userName}}</span>
              </div>
               <div class="userInfo">
                  <span class="userName">{{list.showStr}}</span>
               </div>
            </div>
            <div class="rightCard">
              <span class="loading" v-if="list.status == 0">认证中</span>
              <span class="success" v-if="list.status == 1"></span> <!-- 审核通过 -->
              <span class="error" v-if="list.status == 2">认证失败</span>
              <span class="UntieText" v-if="list.status == 3">已解绑</span>
              <!--activeId = list.id-->
              <img class="edit" v-if="list.status != 0" src="../../assets/images/edit.png" />
            </div>
            <img class="successIcon" v-if="list.status == 1" src="../../assets/images/img_passed@2x.png" />
          </div>
          <div class="editCard" v-if="list.status == 1">
            <mt-button class="setPresermission" @click="edit(list)">设为默认</mt-button>
            <mt-button class="Untie" @click="cancelUserTenant(0)">解绑认证</mt-button>
          </div>
          <mt-button
            class="delete"
            v-if="list.status == 2 || list.status == 3"
            @click="cancelUserTenant(1)"
          >删除</mt-button>
        </div>
      </div>
    </div>

    <div class="addphoneView" v-if="isshowAddPhone &&lists.length > 0">
      <div class="addphonebody" @click="toAddphone" >
         <img class="addphoneImg" src="../../assets/images/icon_addphoen.jpg" />
         <div class="addphone_right">
            <span class="addphone_right_span1">高级实名</span>
            <span class="addphone_right_span2">添加您的人脸信息，使用人脸识别快捷出入办公区域，开门更简单</span>
            <img class="addphone_right_arrow" src="../../assets/images/icon_indicator_next.png"/>
         </div>
      </div>
    </div>

    <div class="footer_box button" v-if="lists.length > 0">
      <mt-button class="p btn_default" @click="addCompany">新增企业认证</mt-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  getUserTenantListByUserId,
  updateUserTenant,
  getUserInfofaceImgUrl,
  cancelUserTenant
} from "../../utils/api";
import util from "../../utils/util";

export default {
  name: "companyList",
  components: {
  },
  data() {
    return {
      lists: "",
      showPage: false,
      activeId: "123",
      isshowAddPhone:false
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  activated() {
    this.getUserTenantListByUserId();
    this.getUserInfofaceImgUrl();
  },
  methods: {
    ...mapActions(['getTenantInfoList','getTenantInfo']),
    addTenement() {
      this.$router.push({
        path: `/addCompany?isToAddPhone=`+this.isshowAddPhone
      });
    },
    getUserInfofaceImgUrl(){
       getUserInfofaceImgUrl({
        userId: this.common.userId,
        marketId: this.common.marketInfo.id,
      }).then(res => {
          console.log(res);
          if (res.res.code == 10000 &&res.body) {
             if(res.body.faceImgUrl && res.body.faceImgUrl.length>0){
                this.isshowAddPhone=false;
             }else{
                this.isshowAddPhone =true;
             }
          }else{
            this.isshowAddPhone =false;
          }
      });
    },
    getUserTenantListByUserId() {
      getUserTenantListByUserId({
        userId: this.common.userId
      }).then(res => {
        console.log(res);
        if (res.body) {
          this.lists = res.body.userTenantList;
          this.getTenantInfoList(res.body.userTenantList)
          for (var i = 0; i < this.lists.length; i++) {
            if(this.lists[i].isDeafult == 1){
              this.getTenantInfo(this.lists[i])
            }
            var items = this.lists[i];
            var emailstr = items.email;
            if (emailstr == null || emailstr.length == 0) {
              //emailstr =" ";
             // items.showStr = items.userName + "; " + items.phone;
                items.showStr = items.phone;
            } else {
              //items.showStr =
                //items.userName + "; " + items.phone + "; " + emailstr;
                items.showStr =  items.phone + "; " + emailstr;
            }
          }
        } else {
          util.showToast("获取失败！");
          setTimeout(() => {
            navigator.pop();
          }, 2000);
        }
        this.showPage = true;
      });
    },
    // 设为默认
    edit(cur) {
      if(cur.isDeafult){
        this.activeId = "";
        return false;
      }
      util.showLoading('处理中...')
      this.activeId = cur.id;
      updateUserTenant({
        userId: this.common.userId,
        id: this.activeId
      }).then(res => {
        console.log(res)
        if(res.res.code === 10000){
          util.hideLoading();
          util.showToast('操作成功')
          this.activeId = "";
          this.getTenantInfo({})
          this.getUserTenantListByUserId();
        }
      })
    },
    setActiveId(item) {
      if(this.activeId == item.id){
        this.activeId = ''
      }else{
      this.activeId = item.id;
      }
    },
    cancelUserTenant(status) {
      console.log(status)
      // "isDrop": 0为解除认证、1为删除认证
      cancelUserTenant(
        {
          userId: this.common.userId,
          id: this.activeId,
          isDrop: status
        }).then(res => {
          console.log(res);
          if (res.res.code === 10000) {
            // if (status) {
            //   this.lists.splice(index, 1);
            // } else {
            //   this.activeId = ''
            //   this.getUserTenantListByUserId();
            // }
            this.getTenantInfo({})
            this.activeId = "";
            this.getUserTenantListByUserId();
          }
        }
      );
    },
    // 新增企业认证
    addCompany(){
      this.$router.push({
         path: `/addCompany?isToAddPhone=`+this.isshowAddPhone
      });
    },
    toAddphone(){
      this.$router.push({
         path:'/addPhoto'
         //path:'/addPhoto'
        // path: `/addCompany`
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.wrapper {
  background-color: #eee;
  display: flex;
  flex-direction: column;
}

.noneTenement {
  flex: 1;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.noneIconbg {
  width: 550px;
  height: 550px;
  margin-top: 160px;
  img {
    display: block;
    width: 550px;
    height: 550px;
  }
}

.noneIcon {
  width: 550px;
  height: 550px;
}

.noneText1 {
  font-size: 36px;
  color: #333333;
  margin-top: 28px;
}

.noneText {
  font-size: 28px;
  line-height: 44px;
  width: 550px;
  color: #999999;
  margin-top: 40px;
  text-align: center;
}

.noneAdd {
  width: 332px;
  height: 76px;
  background-color: @color17;
  border-radius: 4px;
  margin-top: 60px;
  font-size: 32px;
  color: #ffffff;
  line-height: 76px;
  text-align: center;
}

.tenementList {
  flex: 1;
  margin-bottom: 108px;
}
.tenementList1 {
  flex: 1;
  margin-bottom: 328px;
}

.list {
  flex: 1;
  overflow: hidden;
}
.listFoot {
  width: 100%;
  height: 108px;
}

.cardBox {
  margin:20px;
  flex-direction: row;
  transition:left .2s ease-in-out;
  // height: 204px;
  position: relative;
  left:0;
}
.activeCard{
  left:-300px;
}
.activeCard_d{
  left:-156px;
}
.card {
  // height: 292px;
  // height: 204px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding:28px;
  box-sizing: border-box;
  .flex();
  justify-content: space-between;
  position:relative;
}

.leftCard {
  padding-right: 28px;
  flex:1;
  max-width:520px;
}

.titleBox {
  .flex();
  height:40px;
  align-items: center;
  // margin-top: 8px;
}

.presermission {
  width: 64px;
  height: 32px;
  background-color: @color17;
  border-radius: 4px;
  font-size: 24px;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
  margin-right: 10px;
}

.cardTitle {
  font-size: 28px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  flex: 1;
  .textOver(100%);
}

.addressView {
  padding-top: 22px;
  padding-bottom: 28px;
  height:34px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.addressIcon {
  width: 32px;
  height: 32px;
  display:block;
}
.address {
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  padding-left: 12px;
}

.line1{
  height: 2px;
  position:absolute;
  top:150px;left:0;
  width:100%;
}
.userInfo1 {
  margin-top: 28px;
  .flex();
}
.userInfo {
   margin-top:12px;
  .flex();
}

.userName {
  font-size: 24px;
  color: rgba(153, 153, 153, 1);
  .textOver(590px);
  line-height:34px;
}
.userN{
  color:#333;
}

.tel {
  font-size: 28px;
  color: rgba(153, 153, 153, 1);
  padding-left: 28px;
}

.email {
  font-size: 28px;
  color: rgba(153, 153, 153, 1);
}

.rightCard {
  .flex();
  position: relative;
  flex-direction:column;
  justify-content: space-between;
  align-items: flex-end;
}

.loading {
  font-size: 24px;
  color: #ffad5d;
}

.success {
  font-size: 24px;
  color: #16bc84;
}
.successIcon{
  position:absolute;
  width: 100px;
  height: 78px;
  top: 0;
  right: 20px;
}

.error {
  font-size: 24px;
  color: #fc3f56;
}

.UntieText {
  font-size: 24px;
  color: #999999;
}

.edit {
  width: 44px;
  height: 44px;
}

.editCard {
  .flex();
  position: absolute;
  right:-326px;
  top:0;
}
.setPresermission,.Untie,.delete{
  width: 136px;
  height: 292px;
  background-color: @color17;
  border-radius: 8px;
  font-size: 24px;
  color: rgba(255, 255, 255, 1);
  line-height: 292px;
  text-align: center;
  margin-right:14px;
  padding:0;
}
.Untie {
  background-color: rgba(252, 63, 86, 1);
  margin-right:20px;
}

.delete {
  position: absolute;
  right:-176px;
  top:0;
  margin-right:20px;
  background-color: rgba(252, 63, 86, 1);
}

.addphoneView{
  position:fixed;
  bottom:108px;left:0;right:0;
  z-index:100;
  width:100%;
  height:220px;
  background-color: #EEEEEE;
  border-radius:8px;
  overflow:hidden;
}
.addphonebody{
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  height:160px;
  flex-direction: row;
  display: flex;
   background:rgba(255,255,255,1);
  box-shadow:0px 12px 24px 0px rgba(0,0,0,0.16);
  border-radius:8px;
}
.addphoneImg{
  width:160px;
  height:160px;
}
.addphone_right{
  width: 77.5%;
  height:160px;
  flex-direction: column;
  background-color: #FFFFFF;
  position: relative;
  .addphone_right_span1{
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 40px;
    height:42px;
    font-size:30px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:42px;
    display: flex;
  }
  .addphone_right_span2{
     margin-top: 6px;
     margin-left: 20px;
     margin-right: 40px;
     font-size:26px;
    color:rgba(153,153,153,1);
    line-height:36px;
     display: flex;
  }
}
.addphone_right_arrow{
   position:absolute;
   right:20px ;
   top: 64px;
   width: 32px;
   height: 32px;
}


.footer_box{
  position:fixed;
  bottom:0;left:0;right:0;height:108px;
  background:#f3f4f6;
  padding:16px 28px;
  z-index:100;
  box-sizing: border-box;
  .p{
    height:76px;
    width:100%;
    background:@color17;
    border-radius:4px;
    text-align:center;
    line-height:76px;
    color:#fff;
    font-size:32px;
  }
}
</style>
